import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between"} }
const _hoisted_2 = { style: {"display":"flex","justify-items":"space-between","gap":"20px"} }
const _hoisted_3 = {
  key: 0,
  style: {"margin-top":"20px","width":"100%"}
}
const _hoisted_4 = { style: {"margin-left":"20px"} }
const _hoisted_5 = { style: {"display":"flex","justify-content":"flex-end","margin-top":"20px"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" run ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { style: {"flex":"1"} }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "scenarioguide", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.description), 1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.$slots.scenariooption()[0].children.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "scenariooption")
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_select, {
          value: _ctx.scenario?.value,
          style: {"margin-top":"20px","width":"100%"},
          options: _ctx.scenarioOptions,
          onChange: _ctx.onChangeScenario
        }, {
          option: _withCtx(({ label }) => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(label), 1)
          ]),
          _: 1
        }, 8, ["value", "options", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_button, {
          type: "primary",
          disabled: _ctx.disabled,
          loading: _ctx.isLoading,
          onClick: _ctx.onClick
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"])
      ])
    ]),
    _: 3
  }))
}